export const SITE = {
  brand: "VR Ahmedabad Realtors",
  project: "Adani Shantigram",
  phoneDisplay: "+91 90160 75761",
  phoneRaw: "+919016075761",
  whatsappNumber: "919016075761",
  email: "connect@vrahmedabadrealtors.com",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1783125127082-3fb6c1bccd72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwZXh0ZXJpb3IlMjBhcmNoaXRlY3R1cmUlMjBtb2Rlcm58ZW58MHx8fHwxNzg4MTg1ODk1fDA&ixlib=rb-4.1.0&q=85",
  township:
    "https://images.unsplash.com/photo-1783125127243-49158bb610a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwZXh0ZXJpb3IlMjBhcmNoaXRlY3R1cmUlMjBtb2Rlcm58ZW58MHx8fHwxNzg4MTg1ODk1fDA&ixlib=rb-4.1.0&q=85",
  interior1:
    "https://images.unsplash.com/photo-1720247520862-7e4b14176fa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwcHJlbWl1bSUyMGludGVyaW9yfGVufDB8fHx8MTc4ODE4NTg5NXww&ixlib=rb-4.1.0&q=85",
  interior2:
    "https://images.unsplash.com/photo-1639663742190-1b3dba2eebcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwcHJlbWl1bSUyMGludGVyaW9yfGVufDB8fHx8MTc4ODE4NTg5NXww&ixlib=rb-4.1.0&q=85",
  pool: "https://images.unsplash.com/photo-1717972520017-76af413d6b30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjbHViaG91c2UlMjBwb29sfGVufDB8fHx8MTc4ODE4NTg5NXww&ixlib=rb-4.1.0&q=85",
};

export const WA_LINK = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
  "Hi, I'm interested in Adani Shantigram residences (2-6 BHK). Please share pricing and floor plans."
)}`;
